export default __webpack_public_path__ + "static/media/youtube_social_icon_dark.b75d7a0d.png";